<template>
  <div class="enjoy-img" v-if="imgList.length > 0">
    <div class="ele-title">
      <img
        alt=""
        src="https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/title-picture.png"
      />
    </div>
    <div class="box">
      <div class="swiper-wrap">
        <!-- swiper1 -->
        <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
          <swiper-slide :key="index" v-for="(item, index) in imgList">
            <img
              class="item"
              v-lazy="item.subInfo4"
              :key="item.subInfo4"
              alt=""
            />
          </swiper-slide>
        </swiper>
        <!-- swiper2 Thumbs -->
        <swiper
          :options="swiperOptionThumbs"
          class="gallery-thumbs"
          ref="swiperThumbs"
        >
          <swiper-slide :key="index" v-for="(item, index) in imgList">
            <img
              class="item"
              v-lazy="item.subInfo4"
              :key="item.subInfo4"
              alt=""
            />
          </swiper-slide>
        </swiper>
        <div id="enjoy-img-prev" slot="button-prev"></div>
        <div id="enjoy-img-next" slot="button-next"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EnjoyImg',
  props: {
    imgList: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({}),
  created () {
    this.swiperOptionTop = {
      loop: true,
      loopedSlides: 5,
      navigation: {
        nextEl: '#enjoy-img-next',
        prevEl: '#enjoy-img-prev'
      }
    }
    this.swiperOptionThumbs = {
      loop: true,
      spaceBetween: 10,
      slidesPerView: 3,
      touchRatio: 0.2,
      loopedSlides: 5,
      slideToClickedSlide: true
    }
  },
  mounted () {
    // 互相控制
    const swiperTop = this.$refs.swiperTop.swiper
    const swiperThumbs = this.$refs.swiperThumbs.swiper
    swiperTop.controller.control = swiperThumbs
    swiperThumbs.controller.control = swiperTop
  },
  methods: {}
}
</script>
<style lang="less" scoped>
.enjoy-img {
  .title {
    img {
      margin: 0 auto;
      display: block;
      width: 423px;
    }
  }
  .box {
    position: relative;
    margin: 0 auto;
    width: 704px;
    height: 620px;
    padding: 3px;
    box-sizing: border-box;
    background: url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/picture-bg.png')
      no-repeat 50% 0%;
    background-size: 100% 478px;

    .swiper-wrap {
      position: absolute;
      bottom: 3px;
      left: 3px;
      right: 3px;
      top: 3px;
      box-sizing: border-box;
      border-radius: 40px;
      .gallery-top {
        height: 453px;
        width: 680px;
        box-sizing: border-box;
        border: 1px solid #52e5fe;
        margin-top: 10px;
        .swiper-slide {
          .item {
            width: 100%;
            height: 100%;
            background: #efefef
              url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHMAAAApBAMAAAD0eAtEAAAAFVBMVEXv7+/R0dHX19fc3Nzp6eng4ODk5OQNpKnjAAACnElEQVRIx9WWTW/bMAyGPVvRuVQan2M16NnOx85O4u2cbPXdHrD8/5+wl6IVWcpQFOipLKCUlB69JSkGzT5nubUvUUBZazfeWRDREPa+Ea0iz0ToEafbj6LUi70pXuEb5w4/+v4XvAM72oWufq8V9G7rkeb2c+4UFNkQo0ZHu8/jR1DrrD5hqe5ut7XeBDW7yQRNy6QQLrPEjoIuvZ+i4dS+6+Ju0aRqJ0vQcMqk3Tpx4lE969DX6NTfBFWVNFrfKsaWt9utTVE5VS4SNHeisILoj6tE1wmrcctcdEjRyqfW0HPOaCGv7bwLdsAmOrD1bbiIqK/5mei7U21o48oSDIG4720keiKxsiDDO8fkhTTz1xSJchkkVxFFwh1o051JOq4QOCNwgwXRi+yMVObYE9FQ4SZ0a1YmVXMKq3vPh1z+nAgtRDZBcxOu1I2UkFJVkU3RisKN46yeMVqQPNLZ7LzmREFUNkhkIxSyqQ1zUTmBChuWjdEiJVcSWXsSLle4HEU2ecNxrg3Ayg/+C0gaGNV83/son32GI1Y33JUT0Ixl30NFtPXvbamh3KqKq6bxvgd3efoVrqdAB5s+3JT5s1/YXEbKpSM5LVAFhTkvdlnf/97hMUnMLa1GhZQEcx4qmWcto1m53q1RWzVNscTcoU1BS+w8ZfINU2HwD/1bNpr+Su2CNl3r0VK+kjXHeGkMur0noGLNKue7gaLJbcHv3aNPvtVrLNi4Aq3I3NEK6OUB7UZRbVN0jx9Br0RAiUyMvhJJrg9ofVaCKuQK9GVL6whd9Q3QFUrwgGYqzhXu/3P9DIo1QTNB8dh5tLDWR7KVcV+4ZtbXNV/AMd6gckLD/ysNxoohvv1kba1sjU9lYVmG38+WA/AGzfOG1/QP24+i/flJ+D4AAAAASUVORK5CYII=)
              no-repeat 50% 50%;
          }
        }
      }
      .gallery-thumbs {
        box-sizing: border-box;
        height: 200px;
        margin: 0 50px;
        .swiper-slide {
          margin: 0 auto;
          margin-top: 20px;
          height: 127px;
          width: 191px;
          border: 1px solid #52e5fe;
          box-sizing: border-box;
          overflow: hidden;
          text-align: center;
          line-height: 127px;
          .item {
            width: calc(100% - 3px);
            height: calc(100% - 3px);
            background: #efefef
              url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHMAAAApBAMAAAD0eAtEAAAAFVBMVEXv7+/R0dHX19fc3Nzp6eng4ODk5OQNpKnjAAACnElEQVRIx9WWTW/bMAyGPVvRuVQan2M16NnOx85O4u2cbPXdHrD8/5+wl6IVWcpQFOipLKCUlB69JSkGzT5nubUvUUBZazfeWRDREPa+Ea0iz0ToEafbj6LUi70pXuEb5w4/+v4XvAM72oWufq8V9G7rkeb2c+4UFNkQo0ZHu8/jR1DrrD5hqe5ut7XeBDW7yQRNy6QQLrPEjoIuvZ+i4dS+6+Ju0aRqJ0vQcMqk3Tpx4lE969DX6NTfBFWVNFrfKsaWt9utTVE5VS4SNHeisILoj6tE1wmrcctcdEjRyqfW0HPOaCGv7bwLdsAmOrD1bbiIqK/5mei7U21o48oSDIG4720keiKxsiDDO8fkhTTz1xSJchkkVxFFwh1o051JOq4QOCNwgwXRi+yMVObYE9FQ4SZ0a1YmVXMKq3vPh1z+nAgtRDZBcxOu1I2UkFJVkU3RisKN46yeMVqQPNLZ7LzmREFUNkhkIxSyqQ1zUTmBChuWjdEiJVcSWXsSLle4HEU2ecNxrg3Ayg/+C0gaGNV83/son32GI1Y33JUT0Ixl30NFtPXvbamh3KqKq6bxvgd3efoVrqdAB5s+3JT5s1/YXEbKpSM5LVAFhTkvdlnf/97hMUnMLa1GhZQEcx4qmWcto1m53q1RWzVNscTcoU1BS+w8ZfINU2HwD/1bNpr+Su2CNl3r0VK+kjXHeGkMur0noGLNKue7gaLJbcHv3aNPvtVrLNi4Aq3I3NEK6OUB7UZRbVN0jx9Br0RAiUyMvhJJrg9ofVaCKuQK9GVL6whd9Q3QFUrwgGYqzhXu/3P9DIo1QTNB8dh5tLDWR7KVcV+4ZtbXNV/AMd6gckLD/ysNxoohvv1kba1sjU9lYVmG38+WA/AGzfOG1/QP24+i/flJ+D4AAAAASUVORK5CYII=)
              no-repeat 50% 50%;
          }
          &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            text-align: center;
          }
        }
        .swiper-slide-active {
          opacity: 1;
          &::after {
            content: none;
          }
        }
      }
      #enjoy-img-prev {
        position: absolute;
        left: -18px;
        bottom: 33px;
        cursor: pointer;
        background: url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/swiper-btn-prev.png')
          no-repeat 50% 50%;
        background-size: cover;
        width: 49px;
        height: 53px;
        z-index: 100;
        outline: none;
      }
      #enjoy-img-next {
        position: absolute;
        right: -18px;
        bottom: 33px;
        cursor: pointer;
        background: url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/swiper-btn-next.png')
          no-repeat 50% 50%;
        background-size: cover;
        width: 49px;
        height: 53px;
        z-index: 100;
        outline: none;
      }
    }
  }
}
</style>
